module.exports = __webpack_public_path__ + "static/media/Gallery-3.b9d042d6.jpg";